<template>
  <v-dialog
    fullscreen
    :value="showRecordInfo"
    @input="v => v || HIDE_RECORD_INFO()"
  >
    <v-card class="grey lighten-4">
      <!-- CLOSE BTN -->
      <v-card-title class="justify-center grey lighten-4 py-7">
        <v-btn icon large @click="HIDE_RECORD_INFO()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <!-- RECORD -->
      <v-card-text>
        <v-container class="pa-5 white article">
          <!-- TITLE -->
          <h2 class="mb-6" v-html="currentRecord.title"></h2>

          <!-- CAPTION -->
          <div class="caption text-center">
            <img :src="currentRecord.caption">
          </div>

          <div class="flex-grow-1 my-6">
            <div :key="author.id" v-for="(author) in currentRecord.authors">
              <div class="d-flex mb-3">
                <div class="ml-3 mt-3">
                  <img :src="author.image" :alt="author.name" style="max-height: 120px"/>
                </div>
                <div class="grey lighten-5 pa-4 flex-grow-1">
                  <p class="author-name">
                    المؤلف:
                    <span class="primary--text">{{ author.name }}</span>
                  </p>
                  <div class="author-bio">{{ author.bio }}</div>
                </div>
              </div>
            </div>
          </div>

          <!-- SUMMARY -->
          <div
            class="summary pa-5 mb-5 text-subtitle-1 primary grey--text text--lighten-2"
          >{{ currentRecord.summary }}</div>

          <!-- DETAILS -->
          <div class="details pa-6 grey lighten-5 mb-5" v-html="currentRecord.details"></div>

          <!-- ATTACHMENTS -->
          <attachments :record="currentRecord" :deleteMode="false" />

          <hr class="my-5 header-divider" />

          <!-- TRANSLATOR -->
          <div class="grey lighten-4 pa-4">
            <p class="text-subtitle-1">
              ترجمة:
              <span class="primary--text">{{ currentRecord.translator && currentRecord.translator.name }}</span>
            </p>
            <div>{{ currentRecord.translator && currentRecord.translator.bio }}</div>
          </div>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>


<script>
import { mapState, mapMutations } from "vuex";
import Attachments from '@/components/Attachment/List';

export default {
  name: "record-info",
  components: { Attachments },


  computed: {
    ...mapState("news", ['showRecordInfo', 'currentRecord'])
  },


  methods: {
    ...mapMutations("news", ["HIDE_RECORD_INFO"]),
  },


  watch: {
    showRecordInfo(show) {
      if (show) {
        this.$bus.$emit('showSnackbar', {
          text: 'لإغلاق شاشة المعاينة اضغط علي X بالأعلي أو علي زر ESC',
          color: 'blue-grey'
        });
      }
    }
  }
};
</script>
